<template>
    <div
        class="flex flex-col gap-4 border-y border-grey-40 border-solid py-4"
    >
        <p class=" text-grey-90 text-sm">
            {{  t('us.email_sign_up') }}
        </p>

        <form class="flex flex-col gap-4"
              novalidate
              @submit.prevent="register"
        >

            <div>
                <input
                    id="email"
                    ref="emailInputRef"
                    v-model="form.email"
                    type="email"
                    autocomplete="off"
                    maxlength="128"
                    :placeholder="t('us.register_email.email_placeholder')"
                    required
                    class="th-input th-input-lg w-full text-sm placeholder-gray-60"
                    @blur="validateEmail"
                />

                <div
                    v-if="errors.server || errors.email"
                    class="mt-1 text-xs text-red-600"
                >
                    {{ errors.server || errors.email }}
                </div>
            </div>

            <div class="relative">

                <input
                    id="password"
                    ref="passwordRef"
                    v-model="form.password"
                    autocomplete="off"
                    :type="showPassword?'text': 'password'"
                    :placeholder="t('us.register_email.password_placeholder')"
                    required
                    class="th-input th-input-lg w-full pr-8 text-sm placeholder-gray-60"
                    @blur="validatePassword"
                />
                <component :is="showPassword ? EyeOpen : EyeClose"
                           class="th-btn-icon w-5 h-6 fill-gray-400 absolute right-2 top-2 cursor-pointer"
                           @click="showPassword = !showPassword"/>
                <div
                    v-if="errors.password"
                    class="mt-1 text-xs text-red-600"
                >
                    {{ errors.password }}
                </div>
            </div>

            <button
                type="submit"
                class="th-btn th-btn-block th-btn-lg"
                :disabled="form.loading || !form.agreed"
                @click="register"
            >
                {{  t('us.sign_up') }}
            </button>

        </form>

        <div class="flex gap-2 items-start">
            <input
                id="terms"
                class="th-checkbox"
                v-model="form.agreed"
                type="checkbox"
            />
            <label for="terms" class="text-sm text-grey-450"
            >
                <span v-html="t('us.terms_of_service')"></span>
            </label>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useRegister } from '../composables/use-register';
import { useI18n } from 'vue-i18n';
import { ref, defineAsyncComponent } from 'vue';

const { t } = useI18n()

const {
    form,
    register,
    validateEmail,
    validatePassword,
    errors,
    registerPromise,
} = useRegister();

const emits = defineEmits<{
    (e: 'registerSuccess', form: {
        email: string,
        password: string,
        agreed: boolean,
        loading: boolean,
    }): void;
}>();

const showPassword = ref(false);
const EyeClose = defineAsyncComponent(() => import('./EyeClose.vue'))
const EyeOpen = defineAsyncComponent(() => import('./EyeOpen.vue'))

registerPromise.then(() => {
    emits('registerSuccess', form);
});
</script>
